var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumeratorLogoSparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.74553 38.1721C5.16132 38.1721 3.06641 36.0768 3.06641 33.4921V16.8948C3.06641 14.3101 5.16132 12.2148 7.74553 12.2148C10.3298 12.2148 12.4247 14.3101 12.4247 16.8948V33.4921C12.4247 36.0768 10.3298 38.1721 7.74553 38.1721Z",
    fill: "url(#paint0_linear_2297_36481)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.4721 38.1721C21.8879 38.1721 19.793 36.0768 19.793 33.4921V16.8948C19.793 14.3101 21.8879 12.2148 24.4721 12.2148C27.0563 12.2148 29.1512 14.3101 29.1512 16.8948V33.4921C29.1488 36.0768 27.0563 38.1721 24.4721 38.1721Z",
    fill: "url(#paint1_linear_2297_36481)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2058 7.84375H26.7058V10.3438C26.7058 10.6753 26.8375 10.9932 27.0719 11.2276C27.3063 11.4621 27.6243 11.5938 27.9558 11.5938C28.2873 11.5938 28.6053 11.4621 28.8397 11.2276C29.0741 10.9932 29.2058 10.6753 29.2058 10.3438V7.84375H31.7058C32.0373 7.84375 32.3553 7.71205 32.5897 7.47763C32.8241 7.24321 32.9558 6.92527 32.9558 6.59375C32.9558 6.26223 32.8241 5.94429 32.5897 5.70987C32.3553 5.47545 32.0373 5.34375 31.7058 5.34375H29.2058V2.84375C29.2058 2.51223 29.0741 2.19429 28.8397 1.95987C28.6053 1.72545 28.2873 1.59375 27.9558 1.59375C27.6243 1.59375 27.3063 1.72545 27.0719 1.95987C26.8375 2.19429 26.7058 2.51223 26.7058 2.84375V5.34375H24.2058C23.8743 5.34375 23.5563 5.47545 23.3219 5.70987C23.0875 5.94429 22.9558 6.26223 22.9558 6.59375C22.9558 6.92527 23.0875 7.24321 23.3219 7.47763C23.5563 7.71205 23.8743 7.84375 24.2058 7.84375ZM37.9558 12.8438H36.7058V11.5938C36.7058 11.2622 36.5741 10.9443 36.3397 10.7099C36.1053 10.4754 35.7873 10.3438 35.4558 10.3438C35.1243 10.3438 34.8063 10.4754 34.5719 10.7099C34.3375 10.9443 34.2058 11.2622 34.2058 11.5938V12.8438H32.9558C32.6243 12.8438 32.3063 12.9754 32.0719 13.2099C31.8375 13.4443 31.7058 13.7622 31.7058 14.0938C31.7058 14.4253 31.8375 14.7432 32.0719 14.9776C32.3063 15.2121 32.6243 15.3438 32.9558 15.3438H34.2058V16.5938C34.2058 16.9253 34.3375 17.2432 34.5719 17.4776C34.8063 17.7121 35.1243 17.8438 35.4558 17.8438C35.7873 17.8438 36.1053 17.7121 36.3397 17.4776C36.5741 17.2432 36.7058 16.9253 36.7058 16.5938V15.3438H37.9558C38.2873 15.3438 38.6053 15.2121 38.8397 14.9776C39.0741 14.7432 39.2058 14.4253 39.2058 14.0938C39.2058 13.7622 39.0741 13.4443 38.8397 13.2099C38.6053 12.9754 38.2873 12.8438 37.9558 12.8438Z",
    fill: "url(#paint2_linear_2297_36481)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4679 12.2162C27.0521 12.2162 29.147 14.3115 29.147 16.8961C29.147 19.4783 27.0546 21.5736 24.4679 21.576C21.8837 21.576 19.7888 19.4808 19.7888 16.8961C19.7888 14.3115 21.8837 12.2162 24.4679 12.2162Z",
    fill: "url(#paint3_linear_2297_36481)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73772 28.7575C10.3219 28.7575 12.4168 30.8527 12.4168 33.4374C12.4168 36.0196 10.3244 38.1148 7.73772 38.1173C5.15351 38.1173 3.05859 36.022 3.05859 33.4374C3.05859 30.8527 5.15351 28.7575 7.73772 28.7575Z",
    fill: "url(#paint4_linear_2297_36481)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7774 36.8013C25.9505 38.6285 22.9876 38.6285 21.1607 36.8013L4.43342 20.0711C2.60652 18.2439 2.60652 15.2805 4.43342 13.4533C6.26032 11.6261 9.22319 11.6261 11.0501 13.4533L27.7774 30.1835C29.6043 32.0107 29.6043 34.974 27.7774 36.8013Z",
    fill: "url(#paint5_linear_2297_36481)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2297_36481",
    x1: 12.4247,
    y1: 26.8869,
    x2: 3.52798,
    y2: 28.2364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2297_36481",
    x1: 29.1512,
    y1: 26.8869,
    x2: 20.2545,
    y2: 28.2364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2297_36481",
    x1: 39.2058,
    y1: 22.269,
    x2: 9.23245,
    y2: 34.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2297_36481",
    x1: 39.2058,
    y1: 22.269,
    x2: 9.23245,
    y2: 34.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2297_36481",
    x1: 39.2058,
    y1: 22.269,
    x2: 9.23245,
    y2: 34.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2297_36481",
    x1: 39.2058,
    y1: 22.269,
    x2: 9.23245,
    y2: 34.7315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0AEFB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E26C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumeratorLogoSparkle);
export default __webpack_public_path__ + "static/media/numerator-logo-sparkle.38adde3d3abc171d529c305a047c3a41.svg";
export { ForwardRef as ReactComponent };